<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="float-right">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                            <li class="breadcrumb-item active">Transaksi</li>
                            <li class="breadcrumb-item active" v-if="additionalInfo">{{additionalInfo.status == 'WAITING_PROCESS' ? 'Terbitkan' : 'Edit'}} Transaksi</li>
                        </ol>
                    </div>

                    <h4 class="page-title">
                        <router-link :to="{ name: 'instanceTransaction' }">
                            <i class="fas fa-arrow-left mr-2"></i>
                        </router-link>
                        Transaksi
                    </h4>
                </div>
            </div>
        </div>


        <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

        <form v-else>
            <div class="card" v-if="additionalInfo">
                <div class="card-body">
                    <div class="row">
                        <table class="table">
                            <tr>
                                <td style="width: 200px">Nomor Transaksi</td>
                                <td style="width: 10px">:</td>
                                <td>{{additionalInfo.invoice_code}}</td>
                            </tr>
                            <!-- <tr>
                                <td style="width: 200px">Nama</td>
                                <td style="width: 10px">:</td>
                                <td>{{dataCustomer.find(item => item.id == additionalInfo.customer_id).name}}</td>
                            </tr> -->
                            <tr v-if="additionalInfo.invoice_due_date">
                                <td style="width: 200px">Tanggal Jatuh Tempo</td>
                                <td style="width: 10px">:</td>
                                <td>
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <DatePicker :disabled="additionalInfo.status != 'WAITING_PROCESS'" required style="width: 100%"
                                            v-model="additionalInfo.invoice_due_date" valueType="format" placeholder="Masukkan Tanggal Jatuh Tempo" format="DD/MM/YYYY"></DatePicker>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="$store.state.userData.company.is_has_unit">
                                <td style="width: 200px">Unit</td>
                                <td style="width: 10px">:</td>
                                <td>
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <div class="form-group mb-0">
                                                <label>{{additionalInfo.status != 'WAITING_PROCESS' ? 'Unit Sebelumnya' : ''}}</label>
                                                <select class="form-control select-2-form" id="select-2-custom-unit" :disabled="loading"
                                                    v-model="transactionForm.unit" v-select2>
                                                    <option :value="null" selected>--- Pilih Unit ----</option>
                                                    <option :value="item.id" v-for="item in unit" :key="item.id">
                                                        {{item.name ? item.name : '-'}}
                                                        {{item.location ? `(${item.location})` : '-'}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="additionalInfo.status != 'WAITING_PROCESS'">
                                        <div class="col-12 col-md-4 mt-3">
                                            <label>Nama Unit</label>
                                            <input type="text" class="form-control" v-model="formUnit.company_unit_name">
                                        </div>
                                        <div class="col-12 col-md-4 mt-3">
                                            <label>Lokasi Unit</label>
                                            <input type="text" class="form-control" v-model="formUnit.company_unit_location">
                                        </div>
                                        <div class="col-12 col-md-4 mt-3">
                                            <label>NIP</label>
                                            <input type="text" class="form-control" v-model="formUnit.company_unit_nip">
                                        </div>
                                        <div class="col-12 col-md-4 mt-3">
                                            <label>Custom Jabatan 1</label>
                                            <input type="text" class="form-control" v-model="formUnit.company_unit_position_1_name">
                                        </div>
                                        <div class="col-12 col-md-4 mt-3">
                                            <label>Custom Jabatan 2</label>
                                            <input type="text" class="form-control" v-model="formUnit.company_unit_position_2_name">
                                        </div>
                                        <div class="col-12 col-md-4 mt-3">
                                            <label>Custom Jabatan 3</label>
                                            <input type="text" class="form-control" v-model="formUnit.company_unit_position_3_name">
                                        </div>
                                        <div class="col-12 col-md-4 mt-3">
                                            <label>Nama Jabatan</label>
                                            <input type="text" class="form-control" v-model="formUnit.company_unit_placeman_name">
                                        </div>
                                        <div class="col-12 col-md-4 mt-3">
                                            <label>Golongan Jabatan</label>
                                            <input type="text" class="form-control" v-model="formUnit.company_unit_placeman_position">
                                        </div>
                                    </div>
                                </td>
                                <!-- <td colspan="3">
                                    <label class="mt-1 d-block text-right">Unit </label>
                                </td>
                                <td colspan="2">
                                    <div class="form-group mb-0">
                                        <select class="form-control select-2-form" id="select-2-custom-unit" :disabled="loading"
                                            v-model="transactionForm.unit" v-select2>
                                            <option :value="null" selected>--- Pilih Unit ----</option>
                                            <option :value="item.id" v-for="item in unit" :key="item.id">
                                                {{item.name ? item.name : '-'}}
                                                {{item.location ? `(${item.location})` : '-'}}
                                            </option>
                                        </select>
                                    </div>
                                </td> -->
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card mb-0">
                <table class="table mb-0">
                    <thead>
                        <th>Kategori Retribusi</th>
                        <th>Harga</th>
                        <th>Jumlah</th>
                        <th>Total</th>
                    </thead>
                    <tbody v-if="loaderService">
                        <tr>
                            <td colspan="5" class="text-center">
                                <div class="justify-content-center">
                                    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <p class="mt-2">Loading</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <!-- NOTE: NEED TO WORK WITH THIS VALIDATION -->
                        <template v-if="!loading">
                            <Field
                                v-for="(item, index) in transactionForm.objectRetribution"
                                :key="item.index" :dataService="dataService" :index="index"
                                :dataObjectRetribution="transactionForm.objectRetribution"
                                :additionalInfo="additionalInfo"
                                :validationItter="validationItter"
                                @handleData="setData">
                            </Field>
                        </template>

                        <!-- <tr>
                            {{transactionForm.payment_method}}
                            <td colspan="3">
                                <label class="mt-1 d-block text-right">Metode Pembayaran </label>
                            </td>
                            <td colspan="2">
                                <div class="form-group mb-0"
                                    :class="{ 'is-invalid': $v.transactionForm.payment_method.$error }">
                                    <select class="form-control select-2-form-payment" id="select-2-payment"
                                        :disabled="loading || additionalInfo.status != 'WAITING_PROCESS'" v-model.trim="$v.transactionForm.payment_method.$model"
                                        v-select2>
                                        <option value="" selected disabled>--- Pilih Metode Pembayaran ----</option>
                                        <option value="BPD" v-if="this.$store.state.userData.company.payment_methods.includes('BPD')">BPD Bali</option>
                                        <option value="QRIS" v-if="this.$store.state.userData.company.payment_methods.includes('QRIS')">QRIS Dinamis</option>
                                        <option value="QRIS_STATIC" v-if="this.$store.state.userData.company.payment_methods.includes('QRIS_STATIC')">QRIS Statis</option>
                                        <option value="TUNAI" v-if="this.$store.state.userData.company.payment_methods.includes('TUNAI')">Tunai</option>
                                    </select>
                                    <div class="error" v-if="!$v.transactionForm.payment_method.required">Metode
                                        pembayaran wajib diisi</div>
                                </div>
                            </td>
                        </tr> -->

                        <tr>
                            <td colspan="3">
                                <label class="mt-1 d-block text-right">Denda </label>
                            </td>
                            <td colspan="2">
                                <div class="form-group mb-0">
                                    <input class="form-control text-right" type="text" :value="transactionForm.penalty"
                                    readonly :disabled="loading">
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="3">
                                <label class="mt-1 d-block text-right">Total </label>
                            </td>
                            <td colspan="2">
                                <div class="form-group mb-0">
                                    <input class="form-control text-right" type="text" :value="totalPrice"
                                    readonly :disabled="loading">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="additionalInfo">
                <div v-if="additionalInfo.status == 'WAITING_PROCESS'">
                    <button class="btn btn-success waves-effect waves-light mb-5" style="margin-top: 20px" :disabled="loading" @click.prevent="submitForm(false)">
                        Proses Transaksi
                        <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </button>

                    <button class="btn btn-warning waves-effect waves-light mb-5 ml-3" style="margin-top: 20px" :disabled="loading" @click.prevent="submitForm(true)">
                        Proses Semua Transaksi
                        <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </button>
                </div>
                <div v-else>
                    <button class="btn btn-success waves-effect waves-light mb-5" style="margin-top: 20px" :disabled="loading" @click.prevent="saveEdit()">
                        Simpan
                        <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </button>
                </div>
            </div>

            
        </form>

    </div>
</template>

<style>
    .swal2-title{
        font-size: 16px !important;
        font-weight: 600;
    }
    .swal2-html-container{
        font-size: 14 !important;
    }
</style>

<script>
import moment from 'moment'
import Swal from 'sweetalert2'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Field from './fieldProcess'
import { required, integer, minValue } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            loading: true,
            loaderService: false,
            validationItter: { error: false, message: '', index: 0},

            additionalInfo: null,
            name: '',
            period_value: '',
            billing_date: '',
            retributionIds: [],
            unit: [],
            // FORM TRANSACTION
            transactionForm: {
                objectRetribution: [
                    {
                        id: '',
                        price: 0,
                        amount: 1,
                        unit: 1,
                        unit_type: null,
                        total: 0
                    }
                ],
                penalty: 0,
                unit: null,
                payment_method: 'BPD'
            },
            formUnit: {
                company_unit_name: null,
                company_unit_location: null,
                company_unit_position_1_name: null,
                company_unit_position_2_name: null,
                company_unit_position_3_name: null,
                company_unit_placeman_position: null,
                company_unit_nip: null,
            },
            // MASTER DATA
            dataCustomer: [],
            dataService: [],
        }
    },
    validations() {
        return {
            transactionForm: {
                payment_method: { required }
            }
        }
    },
    computed:{
        // COUNT TOTAL PRICE
        totalPrice() {
            return this.transactionForm.objectRetribution.reduce((a, {total}) => a + total, 0) + this.transactionForm.penalty;
        },
        // CONVERT PENALTY PERIOD NAME 
        penaltyPeriodConvert() {
            const period = this.penaltyForm.penalty_period
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Mingguan'
            }else if(period == 'MONTHLY'){
                return 'Bulanan'
            }else{
                return 'Tahunan'
            }
        },
    },
    components: {
        Field,
        DatePicker
    },
    methods: {
        // SET DATA TRANSACTION IN CHILDREN TO PARENT (THIS COMPONENT)
        setData(val) {
            const index = val.index
            this.$set(this.transactionForm.objectRetribution, index,  {
                id: val.id,
                price: parseInt(val.price),
                amount: parseInt(val.amount),
                unit: parseInt(val.unit),
                unit_type: val.unit_type,
                total: parseInt(val.total),
            })
        },
        // LOAD INITIAL DATA THAT NEEDED BEFORE CREATE FORM
        loadInitialData() {
            const customer = this.$http.get(`${this.API_URL}customer`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            const service = this.$http.get(`${this.API_URL}service`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            const unit = this.$http.get(`${this.API_URL}company/unit`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            Promise.all([customer, service, unit])
            .then(([responseCustomer, responseService, responsiveUnit]) => {
                this.dataCustomer = responseCustomer.data.data
                this.dataService = responseService.data.data
                this.unit = responsiveUnit.data.data
                setTimeout(() => {
                    $('.select-2-form').select2();
                    $('.select-2-form-payment').select2();
                    $('.select-2-custom-form').select2();
                    $('.select-2-custom-unit').select2();
                }, 1000);
            })
        },
        // SAVE EDIT TANDA TANGAN
        async saveEdit(){
            this.loading = true
            try {
                const storedData = {
                    company_unit_id: this.transactionForm.unit,
                    company_unit_name: this.formUnit.company_unit_name,
                    company_unit_location: this.formUnit.company_unit_location,
                    company_unit_position_1_name: this.formUnit.company_unit_position_1_name,
                    company_unit_position_2_name: this.formUnit.company_unit_position_2_name,
                    company_unit_position_3_name: this.formUnit.company_unit_position_3_name,
                    company_unit_placeman_position: this.formUnit.company_unit_placeman_position,
                    company_unit_placeman_name: this.formUnit.company_unit_placeman_name,
                    company_unit_nip: this.formUnit.company_unit_nip,
                }
                await this.$http({
                    method: 'PUT',
                    url: `${this.API_URL}transaction/update/${this.$route.params.id}/unit`,
                    data: storedData,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })

                this.sAlert('success', "Berhasil mengupdate tanda tangan transaksi!")
                this.$router.push({ name: 'instanceTransaction' });

                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.errorHandler(error)
            }
        },
        // SUBMIT FORM 
        submitForm(is_bulk_edit) {
            if(this.transactionForm.payment_method == ''){
                this.sAlert('error', 'Harap memilih metode pembayaran terlebih dahulu!')
                return
            }

            if(is_bulk_edit){
                Swal.fire({
                    title: 'Apakah Ingin Memproses Semua Tagihan ?',
                    text: "Apakah anda yakin akan memproses semua tagihan dan menerbitkan tagihannya ?",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#D33',
                    confirmButtonText: 'Ya',
                    cancelButtonText: 'Tidak',
                    allowOutsideClick: () => { return false }
                }).then(async (result) => {
                    if(result.isDismissed){
                        Swal.close()
                        return
                    }else{
                        this.storeData(is_bulk_edit)
                    }
                })
            }else{
                this.storeData(is_bulk_edit)
            }
        },
        storeData(is_bulk_edit){
            if (this.$v.$invalid) {
                if(this.$v.transactionForm.$invalid){
                    $('.nav-item a[href="#pills-index"]').tab('show');
                }else{
                    $('.nav-item a[href="#pills-forfeit"]').tab('show');
                }
                this.$v.$touch()
                this.sAlert('error', 'Harap isi semua form dengan benar!')
                return
            }

            // CHECK VALIDATION ON SERVICES
            this.validationItter = { error: false, message: '', index: 0}
            for (const [index, element] of this.transactionForm.objectRetribution.entries()) {
                if(element.id == ''){ 
                    this.validationItter.error = true
                    this.validationItter.message = 'Kategori Retribusi wajib dipilih'
                    this.validationItter.index = index
                    break
                }else if(element.amount <= 0 || element.amount == ''){
                    this.validationItter.error = true
                    this.validationItter.message = 'Jumlah wajib diisi atau tidak boleh kurang dari 0'
                    this.validationItter.index = index
                    break
                }
            }

            // CHECK VALIDATION
            if(this.validationItter.error){
                $('.nav-item a[href="#pills-index"]').tab('show');
                this.sAlert('error', this.validationItter.message)
                return
            }else{
                this.validationItter.error = false
            }

            this.loading = true

            // SET STORED DATA
            let storedData = null
            
            if(this.additionalInfo.invoice_due_date){
                storedData = {
                    name: this.name, 
                    period_value: this.period_value, 
                    billing_date: this.billing_date, 
                    retributionIds: this.retributionIds,
                    is_bulk_edit: is_bulk_edit ? 1 : 0,
                    due_date: this.additionalInfo.invoice_due_date,
                    objectRetribution: this.transactionForm.objectRetribution,
                    total: this.totalPrice - this.transactionForm.penalty,
                    payment_method: this.transactionForm.payment_method,
                    company_unit_id: this.transactionForm.unit ? this.transactionForm.unit : null
                }
            }else{
                storedData = {
                    name: this.name, 
                    period_value: this.period_value, 
                    billing_date: this.billing_date, 
                    retributionIds: this.retributionIds,
                    is_bulk_edit: is_bulk_edit ? 1 : 0,
                    objectRetribution: this.transactionForm.objectRetribution,
                    total: this.totalPrice - this.transactionForm.penalty,
                    payment_method: this.transactionForm.payment_method,
                    company_unit_id: this.transactionForm.unit ? this.transactionForm.unit : null
                }
            }

            // STORE TRANSACTION
            this.$http({
                method: 'PUT',
                url: `${this.API_URL}transaction/update/${this.$route.params.id}`,
                data: storedData,
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                const result = response.data;
                
                if(result.success) {
                    this.sAlert('success', "Berhasil memproses transaksi!")
                    this.$router.push({ name: 'instanceTransaction' });
                }else {
                    this.sAlert('error', result.message)
                }
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.errorHandler(error)
            });
        }
    },
    watch: {
        'transactionForm.unit': {
            handler(value){
                const unit = this.unit.find(item => {
                    return item.id == this.transactionForm.unit
                })

                console.log(unit);

                this.formUnit.company_unit_name = unit.name
                this.formUnit.company_unit_location = unit.location
                this.formUnit.company_unit_position_1_name = unit.position_1_name
                this.formUnit.company_unit_position_2_name = unit.position_2_name
                this.formUnit.company_unit_position_3_name = unit.position_3_name
                this.formUnit.company_unit_placeman_name = unit.placeman_name
                this.formUnit.company_unit_nip = unit.nip
                this.formUnit.company_unit_placeman_position = unit.placeman_position

            }
        }
    },
    async mounted() {
        this.loading = true;
        await this.loadInitialData()
        
        this.$http({
            method: 'get',
            url: `${this.API_URL}transaction/${this.$route.params.id}`,
            headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
        })
        .then(response => {
            const result = response.data;
            if(result.success) {
                this.additionalInfo = result.data
                this.additionalInfo.invoice_due_date ? this.additionalInfo.invoice_due_date = moment(result.data.invoice_due_date).format('DD/MM/YYYY') : null
                this.name = 'Update Transaksi ' + result.data.invoice_code,
                this.period_value = null,
                this.billing_date = null,
                this.retributionIds.push(result.data.customer_id),
                this.transactionForm = {
                    objectRetribution: result.data.objectRetribution.map(item => {
                        return {
                            id: item.service_id,
                            price: item.price,
                            amount: item.qty,
                            unit: item.unit,
                            unit_type: item.unit_type,
                            total: item.total,
                        }
                    }),
                    payment_method: result.data.payment_method,
                    unit: result.data.company_unit_id,
                    penalty: result.data.penalty ? result.data.penalty.amount : 0
                }
                this.formUnit = {
                    company_unit_name: result.data.company_unit_name,
                    company_unit_location: result.data.company_unit_location,
                    company_unit_placeman_name: result.data.company_unit_placeman_name,
                    company_unit_position_1_name: result.data.company_unit_position_1_name,
                    company_unit_position_2_name: result.data.company_unit_position_2_name,
                    company_unit_position_3_name: result.data.company_unit_position_3_name,
                    company_unit_placeman_position: result.data.company_unit_placeman_position,
                    company_unit_nip: result.data.company_unit_nip,
                }
                this.loading = false;
            }else {
                this.sAlert('error', result.message)
                this.loading = false;
            }

            this.transactionForm.payment_method = 'BPD'
        })
        .catch(error => {
            this.loading = false;
            this.sAlert('error', "Error, Terjadi Kesalahan!")
        });
    }
}
</script>

<style>

</style>